import React from 'react';
import bem from 'utils/bem';
import SocialIcons from 'components/SocialIcon/SocialIcons';
import Logo from 'components/Logo';
import Text from 'components/Text';
import AddressAndPhones from 'components/AddressAndPhones';
import Links from './Links';
import { credentials, docs } from './credentials';

import './index.sass';

const { block, el } = bem('footer');

const Footer = () => {
    const siteVersion = location.hostname.includes('otvetco.kz') && window.country === 'KZ' ? 'kz' : 'ru';
    const siteCredentials = credentials[siteVersion];
    const siteDocs = docs[siteVersion]

    const ofertaLink = siteDocs['ofertaLink'];
    const confidentLink = siteDocs['confidentLink'];
    const userAgreementLink = siteDocs['userAgreementLink'];

    return (
        <div className={ block() }>
            <div className={ el('upper') }>
                <div className={ el('content')} >
                    <div className={ el('top') }>
                        <div className={ el('logo') }>
                            <Logo/>
                        </div>
                        <div className={ el('socials') }>
                            <SocialIcons mod={ 'white' }/>
                        </div>
                        <Links/>
                        <AddressAndPhones />
                    </div>
                    <div className={el('credentials')}>
                        <Text dangerouslySetInnerHTML={{__html: siteCredentials}} />
                    </div>
                </div>
            </div>
            <div className={ el('lower') }>
                <div className={ el('content') }>
                    <div className={ el('copyright') }>
                        <Text>{ new Date().getFullYear() } Otvet. Все права защищены</Text>
                    </div>
                    <div className={ el('links') }>
                        <a href={ ofertaLink } target="_blank" className={ el('oferta') }>
                            <Text>Оферта</Text>
                        </a>
                        <a href={ userAgreementLink } target="_blank" className={ el('user-agreement') }>
                            <Text>Пользовательское соглашение</Text>
                        </a>
                        <a href={ confidentLink } target="_blank" className={ el('confidential') }>
                            <Text>Политика конфиденциальности</Text>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
